const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      initDisqus();
      // Stop observing the element after it has been detected
      observer.unobserve(entry.target);
    }
  });
}, {
  rootMargin: getRootMargin() // Trigger when the user scrolls past the middle of the page, and no less than 700px
});

// Observe a target element
const targetElement = document.querySelector('#disqus_thread');
observer.observe(targetElement);

function initDisqus() {
  var d = document, s = d.createElement('script');
  s.src = 'https://potv.disqus.com/embed.js';
  s.setAttribute('data-timestamp', + new Date());
  s.setAttribute('defer', 'defer');
  (d.head || d.body).appendChild(s);
}

function getRootMargin() {
  const halfScrollHeight = document.documentElement.scrollHeight / 2;
  return halfScrollHeight < 700 ? '700px' : halfScrollHeight + 'px';
}